import React from "react";
import style from "./AddNewChannels.module.css";
import Button from "../button/Button";
import { IoAdd } from "react-icons/io5";
import CommonTable from "../commonTable/CommonTable";
// import { ColumnsNewChannel } from "./Data";

const AddNewChannels = () => {
    const  data = []
    return (
        <div>

            <CommonTable
                heading="Live TV Channels"
                // columns={ColumnsNewChannel}
                data={data}
                Library="Library"
                containerClassName={style.customContainerOverride}
                extraButton={
                    <Button iconLeft={<IoAdd className={style.arrowIcon} />}>
                        New Channel
                    </Button>
                }
            />
        </div>
    );
};

export default AddNewChannels;
